import { render } from "./CollectorInstalledPage.vue?vue&type=template&id=41a36ed4&ts=true"
import script from "./CollectorInstalledPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectorInstalledPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/agents/pages/collectorInstalled/CollectorInstalledPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41a36ed4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41a36ed4', __exports__)) {
    api.reload('41a36ed4', __exports__)
  }
  
  module.hot.accept("./CollectorInstalledPage.vue?vue&type=template&id=41a36ed4&ts=true", () => {
    api.rerender('41a36ed4', render)
  })

}


export default __exports__